import { Text } from 'react-native'
import { useRouter } from 'expo-router'
import { useTranslation } from 'react-i18next'

import { Button, ModalBody, ModalFooter, ModalHeader, ModalTitle, useModal } from '@/components/base'

function SetTxPasswordModal({ onCancel, onSubmit }: { onCancel?: () => void; onSubmit?: () => void }) {
  const { t } = useTranslation()
  const router = useRouter()
  const { closeModal } = useModal()

  function handleSubmit() {
    closeModal()
    router.push('/(main)/setting/tx-password')
  }
  return (
    <>
      <ModalHeader className={'p-4'}>
        <ModalTitle>{t('ui:setTransactionPassword')}</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Text className={'text-sm text-text-secondary'}>{t('ui:setTransactionPasswordDescription')}</Text>
      </ModalBody>
      <ModalFooter>
        <Button className={'flex-1'} variant={'outline'} size={'md'} onPress={onCancel || closeModal}>
          {t('ui:gotIt')}
        </Button>
        <Button className={'flex-1'} size={'md'} onPress={onSubmit || handleSubmit}>
          {t('ui:goToSettings')}
        </Button>
      </ModalFooter>
    </>
  )
}

export default SetTxPasswordModal
